import React, { useState } from 'react';
import { Form, Row, Col, Button, Collapse } from 'react-bootstrap';
import { FaSearch, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import IntegerInput from '../Utils/IntegerInput';
import SelectInput from '../Utils/SelectInput';
import { StatusType } from '../Enum/StatusType';

const PersonFilter = ({ onFilter, onClear }) => {
  const [oldId, setOldId] = useState('');
  const [name, setName] = useState('');
  const [document, setDocument] = useState('');
  const [status, setStatus] = useState('ATIVO');
  const [open, setOpen] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();

    const filters = {
      oldId: oldId || undefined,
      name: name || undefined,
      document: document || undefined,
      includeCustomer: true,
      includeSupplier: true,
      includeDriver: true,
      includeProducer: true,
      active: status === 'ATIVO' ? true : false
    };

    onFilter(filters);
  };

  const handleClear = () => {
    setOldId('');
    setName('');
    setDocument('');
    setStatus('ATIVO');
    onClear();
  };

  const handleToggle = () => {
    setOpen(!open);
    if (open) {
      handleClear();
    }
  };

  return (
    <div
      style={{
        border: open ? '1px solid black' : 'none',
        borderRadius: '5px',
        padding: open ? '10px' : '0px',
        marginBottom: '20px',
        transition: 'all 0.3s ease-in-out'
      }}
    >
      <h6
        className="text-center mb-3 d-flex align-items-center justify-content-center"
        style={{ cursor: 'pointer' }}
        onClick={handleToggle}
      >
        Filtros Avançados{' '}
        {open ? <FaChevronUp className="ms-2" /> : <FaChevronDown className="ms-2" />}
      </h6>
      <Collapse in={open}>
        <div>
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={2}>
                <Form.Group controlId="oldId" className="mb-3">
                  <IntegerInput
                    label="Código"
                    value={oldId}
                    onChange={setOldId}
                    placeholder="Código"
                    userRoles={false}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="name" className="mb-3">
                  <Form.Label className="mb-1">Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="document" className="mb-3">
                  <Form.Label className="mb-1">Documento</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Documento"
                    value={document}
                    onChange={(e) => setDocument(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <SelectInput
                  label="Status"
                  value={status}
                  onChange={setStatus}
                  data={StatusType}
                  isOption={false}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-flex justify-content-start">
                <Button
                  variant="primary"
                  type="submit"
                  className="button-custom d-flex align-items-center me-2"
                >
                  <FaSearch className="me-2" /> Pesquisar
                </Button>
                <Button
                  variant="secondary"
                  onClick={handleClear}
                  className="d-flex align-items-center"
                >
                  Limpar
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Collapse>
    </div>
  );
};

export default PersonFilter;